export interface FriendlyError {
    friendly: string
}

const isFriendlyError = (error: unknown): error is FriendlyError => {
    return (
        typeof error === "object" &&
        error !== null &&
        "friendly" in error &&
        typeof error.friendly === "string"
    )
}

export const friendlyError = (error: unknown) => {
    if (isFriendlyError(error)) return error.friendly
    return "Something went wrong!"
}
